import { Root } from '@radix-ui/react-accessible-icon';

import { styled } from '../stitches.config';

export const AccessibleIcon = styled(Root, { flexShrink: 0 });
